import Vue from "vue";
import Router from "vue-router";
import store from "../store";

const Login = () => import("@/components/Login");
const Restaurants = () => import("@/components/Restaurants");
const Profile = () => import("@/components/user/Profile");
const MyOrders = () => import("@/components/user/MyOrders");
const OrderDetail = () => import("@/components/user/OrderDetail");
const ForgotPassword = () => import("@/components/ForgotPassword");
const ResetPassword = () => import("@/components/ResetPassword");
const InstructionsSent = () => import("@/components/InstructionsSent");
const Payment = () => import("@/components/Payment");
const Faq = () => import("@/components/Faq");
const TermsOfUse = () => import("@/components/TermsOfUse");
const Error404 = () => import("@/components/common/Error404");
const OfficeAdmin = () => import("@/components/OfficeAdmin/OfficeAdmin");
const OfficeEmployees = () =>
  import("@/components/OfficeAdmin/OfficeEmployees");
const RestaurantOrdersDetail = () =>
  import("@/components/OfficeAdmin/RestaurantOrdersDetail");
const PlaceOrder = () =>
  import("@/components/OfficeAdmin/PlaceOrder/PlaceOrder");
const Teams = () => import("@/components/OfficeAdmin/Teams/Teams");
const TeamDetail = () => import("@/components/OfficeAdmin/Teams/TeamDetail");

import { isLoggedIn, clearPKToken, getEmployeeProfile } from "@/utils/api";

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },

  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
      meta: { redirectIfLoggedIn: true }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { redirectIfLoggedIn: true }
    },
    {
      path: "/office/do_login_admin",
      name: "AdminLogin",
      component: Login,
      meta: { redirectIfLoggedIn: true }
    },
    {
      path: "/restaurants",
      name: "Restaurants",
      component: Restaurants,
      meta: { private: true }
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: { private: true }
    },
    {
      path: "/orders",
      name: "Orders",
      component: MyOrders,
      meta: { private: true }
    },
    {
      path: "/forget-password",
      name: "ForgotPassword",
      component: ForgotPassword
    },
    {
      path: "/office/reset_password",
      name: "Reset Password",
      component: ResetPassword
    },
    {
      path: "/new-account",
      name: "Reset Password",
      component: ResetPassword
    },
    {
      path: "/instructions-sent",
      name: "InstructionsSent",
      component: InstructionsSent
    },
    {
      path: "/payment",
      name: "Payment",
      component: Payment,
      meta: { private: true }
    },
    {
      path: "/orderdetail",
      name: "OrderDetail",
      component: OrderDetail
    },
    {
      path: "/faq",
      name: "Faq",
      component: Faq,
      meta: { private: true }
    },
    {
      path: "/terms-of-use",
      name: "TermsOfUse",
      component: TermsOfUse,
      meta: { private: true }
    },
    {
      path: "/admin/restaurant-orders/:restaurant",
      name: "RestaurantOrdersDetail",
      component: RestaurantOrdersDetail,
      meta: { officeAdmin: true, private: true }
    },
    {
      path: "/admin/teams/:team",
      name: "team-detail",
      component: TeamDetail,
      meta: { officeAdmin: true, private: true }
    },
    {
      path: "/admin",
      name: "OfficeAdmin",
      component: OfficeAdmin,
      meta: { officeAdmin: true, private: true }
    },
    // {
    //   path: "/office-orders",
    //   name: "OfficeOrders",
    //   component: OfficeOrders
    // },
    {
      path: "/admin/users",
      name: "office-employees",
      component: OfficeEmployees,
      meta: { officeAdmin: true, private: true }
    },

    {
      path: "/admin/order",
      name: "place-order",
      component: PlaceOrder,
      meta: { officeAdmin: true, private: true }
    },
    {
      path: "/admin/teams",
      name: "office-teams",
      component: Teams,
      meta: { officeAdmin: true, private: true }
    },
    {
      path: "/*",
      name: "Error404",
      component: Error404,
      meta: {
        error404: true
      }
    }
  ]
});

/**
 * Do not throw an exception if push is rejected by redirection from navigation guard
 */
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return new Promise((resolve, reject) => {
    originalPush.call(
      this,
      location,
      () => {
        // on complete

        resolve(this.currentRoute);
      },
      error => {
        resolve(this.currentRoute);
      }
    );
  });
};

router.onError(err => {
  console.log("<!-- router error: " + err.message + " -->");
});

router.beforeEach((to, from, next) => {
  const role = store.state.currentEmp && store.state.currentEmp.role;
  const teamAdmin = store.state.currentEmp && store.state.currentEmp.team_admin;

  const softDeletedEmployee =
    store.state.currentOrganization &&
    store.state.currentOrganization.attributes.soft_deleted;

  store.commit("HIDE_ADMIN_MENU");
  store.commit("RESET_ADMIN_BUTTON_MENU");
  if (from.meta.officeAdmin === true) clearPKToken();

  if (to.meta.officeAdmin === true && window.innerWidth < 768) {
    store.commit("SHOW_ADMIN_BUTTON_MENU");
  } else {
    store.commit("SHOW_ADMIN_MENU");
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (
    !((role && role == "admin") || teamAdmin) &&
    to.meta.officeAdmin === true
  ) {
    try {
      next("./restaurants");
    } catch (err) {}
  }

  if (
    softDeletedEmployee &&
    to.name != "Profile" &&
    to.name != "Orders" &&
    to.name != "Faq"
  ) {
    try {
      next("./orders");
    } catch (err) {
      console.log(err);
    }
  }

  if (
    to.meta.private &&
    from.name !== "Login" &&
    store?.state?.employee?.email &&
    store?.getters?.getFirstEmployeeId
  ) {
    getEmployeeProfile(
      store.state.employee.email,
      store.getters.getFirstEmployeeId,
      store.state.currentOrganization
    ).then(result => {
      if (result && result.data && result.data.attributes) {
        store.commit("UPDATE_EMPLOYEE", result.data);
      }
    });
  }

  if (to.meta.private && !isLoggedIn()) {
    try {
      const loginpath = window.location.pathname;
      next({ name: "Login", query: { from: loginpath } });
    } catch (err) {}
  } else if (to.meta.redirectIfLoggedIn && isLoggedIn()) {
    try {
      next("./restaurants");
    } catch (err) {}
  } else if (to.meta.error404 && !isLoggedIn()) {
    window.location.href = "https://www.hungerhub.com/404/";
  } else next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js